// extracted by mini-css-extract-plugin
export default {"title":"TitleBg_title__kNPAZ"};